<div class="container-fluid py-4">
  <div class="py-4 heading-container">
    <div class="d-inline-block align-middle me-2">
      <svg-icon src="assets/icons/icon-connections.svg" class="icon-connections"></svg-icon>
    </div>
    <h1 class="d-inline-block align-middle m-0">{{ 'PATIENT_LINKS_PAGE_TITLE' | translate }}</h1>
  </div>
  <router-outlet></router-outlet>
</div>
